<!-- Responsive Design-->
<p-dialog [(visible)]="displayStatic" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'create-contact-dialog'"
          [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'max-width':'700px','width':'100%'}" [resizable]="false">

    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2">
            <h6 class="resolve-title">RESOLVE INQUIRY</h6>
            <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
                <h6>CLOSE</h6>
            </button>
        </div>
    </p-header>
    <div class="resolve-body mx-2">
        <form class="form-horizontal" [formGroup]="resolveInquiryForm" novalidate (ngSubmit)="onResolveSubmit()">
            <div class="errorMsg">{{gfidMissingErr}}</div><br>
            <div class="errorMsg">{{resolveErrorMessage}}</div>
            <div class="errorMsg">{{requestTypeErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{tagErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{rootCauseErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{processingRegionErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{inqSourceErrorMessageForAllGroup}}</div>
            <!--changes regarding C170665-365 to provide an option to assign gfcid, when gfcid is missing-->
            <div *ngIf="gfidMissingErr" class="">
            <div class="lookup-container">
                <button class="btn btn-default lookup-button">
                    <img src="assets/qwyn/icons/search-blue.svg" alt="Search" class="lookup-icon" />
                </button>
                <a href="#" class="TextGFP lookup-link" (click)="callGFIDWindow()">External Client ID / Name Look up</a>
            </div>
            </div><br>
            <div class="d-flex flex-row align-items-center mb-4 resolveDir" id="resolveFromstyle" style="display:block" *ngIf="!resolveAll">
                <div class="label-text resolveLabel" for="from">From :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="groupNames" formControlName="groupName" [styleClass]="'prime-dd-override'" optionLabel="value"
                                (onChange)="onGroupChange($event)">
                    </p-dropdown>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="request">Request :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="requestTypes" formControlName="requestType" (onChange)="onRequestTypeChange($event)" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.requestType.errors && (resolveInquiryForm.controls.requestType.dirty || resolveInquiryForm.controls.requestType.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Request Type is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="tag">Tag :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="tags" formControlName="tags" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.tags.errors && (resolveInquiryForm.controls.tags.dirty || resolveInquiryForm.controls.tags.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Tag is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="cause">Cause :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="rootCauses" formControlName="rootCause" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="isSubmitClicked && resolveInquiryForm.controls.rootCause.errors && (resolveInquiryForm.controls.rootCause.dirty || resolveInquiryForm.controls.rootCause.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Root Cause is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="region">Region :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="processingRegions" formControlName="processingRegion" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.processingRegion.errors && (resolveInquiryForm.controls.processingRegion.dirty || resolveInquiryForm.controls.processingRegion.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Processing Region is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="source">Source :</div>
                <div class="dd-comp ddMob">
                    <p-dropdown class="drop-down" [options]="inquirySourceList" formControlName="inquirySource" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySource.errors && (resolveInquiryForm.controls.inquirySource.dirty || resolveInquiryForm.controls.inquirySource.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Inquiry Source is Required
                    </div>
                </div>
            </div>
            <!--[C170665-1719] DCC Requirement: Add Case status field -->
            <div class="input-group mb-2 " *ngIf="enableInquirySubStatusFlag">
                <label class="form-label">Sub-Status 1:</label>
                <div class="input-container">
                    <p-dropdown class="drop-down" [options]="inquirySubStatusList" formControlName="inquirySubStatus" [styleClass]="'prime-dd-override'">
                    </p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySubStatus.errors && (resolveInquiryForm.controls.inquirySubStatus.dirty || resolveInquiryForm.controls.inquirySubStatus.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Inquiry Sub-Status is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-start mb-4 resolveDir" *ngIf="!hideQueries">
                <div class="label-text resolveLabel" for="queries">Queries :</div>
                <div class="dd-comp ddMob">
                    <input type="text" formControlName="queryCount" placeholder="Type here">
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.queryCount.errors?.max && (resolveInquiryForm.controls.queryCount.dirty || resolveInquiryForm.controls.queryCount.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Please enter a query count from 1-9999 inclusive
                    </div>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.queryCount.errors?.min && (resolveInquiryForm.controls.queryCount.dirty || resolveInquiryForm.controls.queryCount.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Please enter valid query count!
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel"></div>
                <div class="dd-comp ddMob" [class.hide]="hide">
                    <div class="custom-control custom-checkbox" style="margin-top:20px">
                        <input type="checkbox" class="custom-control-input" id="resolveAll" formControlName="resolveAll" (change)="resolveForAllChecked($event)">
                        <label class="custom-control-label" for="resolveAll">Resolve for all my groups</label>
                    </div>
                    <!-- C170665-119Add new QMA option as Allocation -->
                    <div class="custom-control custom-checkbox" style="margin-top:15px">
                        <input type="checkbox" class="custom-control-input" id="resolveAllocation" formControlName="resolveAllocation" (change)="resolveAllocationChecked($event)">
                        <label class="custom-control-label" for="resolveAllocation">Resolve allocation</label>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center mb-4 resolveDir" >
                <div class="label-text resolveLabel"></div>
                <div class="dd-comp ddMob">
                    <div class="custom-control custom-checkbox" > <!-- #checkBoxForceResolveDiv -->
                        <input type="checkbox" class="custom-control-input" id="forceResolve" formControlName="forceResolve" (change)="forceResolve($event)" >
                        <label class="custom-control-label" for="forceResolve">Force Resolve</label>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="label-text resolveLabel" for="comments"></div>
                <div class="d-flex flex-row align-items-center input-holder dd-comp ddMob">
                    <div class="d-flex flex-row w-100 align-items-center">
                        <textarea rows="4" cols="50" formControlName="comments"></textarea>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center mb-4 resolveDir">
                <div class="errorMsg">{{lockErrorMsg}}</div>
            </div>

            <p-footer>
                <div class="d-flex flex-row flex-wrap  px-3 justify-content-end">
                    <button type="submit" class="btn search-btn me-4 mobile-btn" id="resolveSubmitBtn" name="resolveSubmitBtn" [disabled]="disableSubmit">Submit</button>
                    <button type="reset" class="btn clear-btn mobile-btn" (click)="resetResolveInquiry(resolveInquiryForm)" [disabled]="hide">Reset</button>
                </div>
            </p-footer>
        </form>
    </div>
</p-dialog>

<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'resolve-inquiry-dialog'"
          [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true"
          [resizable]="true" [draggable]="true" [contentStyle]="{'height': 'auto', 'overflow': 'visible'}">

    <div class="dialog-header">
        <div class="d-flex flex-row align-items-center justify-content-between header-resolve-inquiry">
            <h6 class="resolve-inquiry-title">Resolve Inquiry</h6>
            <div class="close-button" (click)="hideModal()">
                <img src="assets/qwyn/icons/close.svg" alt="close">
            </div>
        </div>
    </div>

    <div #dialogContent class="p-dialog-content">
        <form class="form-horizontal" [formGroup]="resolveInquiryForm" novalidate (ngSubmit)="onResolveSubmit()">
            <div class="errorMsg" style="margin-left:19px;">{{gfidMissingErr}}</div>
            <div class="errorMsg">{{resolveErrorMessage}}</div>
            <div class="errorMsg">{{requestTypeErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{tagErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{rootCauseErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{processingRegionErrorMessageForAllGroup}}</div>
            <div class="errorMsg">{{inqSourceErrorMessageForAllGroup}}</div>
            <!--changes regarding C170665-365 to provide an option to assign gfcid, when gfcid is missing-->
            <div *ngIf="gfidMissingErr && mandatoryForResolveFlags[0] && mandatoryForResolveFlags[0].isGfidMandatory" style="margin-left:19px;">
            <div class="lookup-container">
                <button class="btn btn-default lookup-button">
                    <img src="assets/qwyn/icons/search-blue.svg" alt="Search" class="lookup-icon" />
                </button>
                <a href="#" class="TextGFP lookup-link" (click)="callGFIDWindow()">External Client ID / Name Look up</a>
            </div>
            </div>
            <div class="input-group mb-2 " id="resolveFromstyle" [ngClass]="{'hidden-content':resolveAll}">
                <label class="form-label">From:</label>
                <div class="input-container">
                    <input readonly class="resolve-form-control-disabled" formControlName="groupName" [ngStyle]="{'cursor': 'default'}">
                </div>
            </div>

            <div class="input-group mb-2 ">
                <label class="form-label">Request Type:</label>
                <div class="input-container">
                    <p-dropdown [options]="requestTypes" formControlName="requestType" (onChange)="onRequestTypeChange($event)"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" placeholder="Select Request Type"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.requestType}" (onShow)="dropdownStates.requestType = true"
                        (onHide)="dropdownStates.requestType = false"></p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.requestType.errors && (resolveInquiryForm.controls.requestType.dirty || resolveInquiryForm.controls.requestType.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> RequestType is Required
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0]?.isTagMandatory)">
                <label class="form-label">Tag:</label>
                <div class="input-container">
                    <p-dropdown [options]="tags" formControlName="tags" (onChange)="onRequestTypeChange($event)"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" placeholder="Select Tag"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.tags}" (onShow)="dropdownStates.tags = true"
                        (onHide)="dropdownStates.tags = false"></p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.tags.errors && (resolveInquiryForm.controls.tags.dirty || resolveInquiryForm.controls.tags.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Tags is Required
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0]?.isRootCauseMandatory)">
                <label class="form-label">Cause:</label>
                <div class="input-container">
                    <p-dropdown [options]="rootCauses" formControlName="rootCause"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.cause}" (onShow)="dropdownStates.cause = true"
                        (onHide)="dropdownStates.cause = false"></p-dropdown>
                    <div class="invalid-feedback" *ngIf="isSubmitClicked && resolveInquiryForm.controls.rootCause.errors && (resolveInquiryForm.controls.rootCause.dirty || resolveInquiryForm.controls.rootCause.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Root Cause is Required
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0]?.isProcessingRegionMandatory || mandatoryForResolveFlags[0]?.isProcessingRegionMandatory)">
                <label class="form-label">Region:</label>
                <div class="input-container">
                    <p-dropdown [options]="processingRegions" formControlName="processingRegion"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" placeholder="Select Region"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.region}" (onShow)="dropdownStates.region = true"
                        (onHide)="dropdownStates.region = false"></p-dropdown>
                    <div *ngIf="resolveInquiryForm.controls.processingRegion.errors && (resolveInquiryForm.controls.processingRegion.dirty || resolveInquiryForm.controls.processingRegion.touched)"
                         class="error-message">
                        <img src="assets/newMessage/error.svg" class="error"> Processing Region is Required
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0]?.isInqSourceMandatory || mandatoryForResolveFlags[0]?.isInqSourceMandatory)">
                <label class="form-label">Source:</label>
                <div class="input-container">
                    <p-dropdown [options]="inquirySourceList" formControlName="inquirySource"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.source}" (onShow)="dropdownStates.source = true"
                        (onHide)="dropdownStates.source = false"></p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySource.errors && (resolveInquiryForm.controls.inquirySource.dirty || resolveInquiryForm.controls.inquirySource.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Inquiry Source is Required
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " *ngIf="enableInquirySubStatusFlag && mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0]?.enableInquirySubStatus || mandatoryForResolveFlags[0]?.enableInquirySubStatus)">
                <label class="form-label">Sub-Status:</label>
                <div class="input-container">
                    <p-dropdown [options]="inquirySubStatusList" formControlName="inquirySubStatus"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                        [ngClass]="{'signatureDropdown-open': dropdownStates.subStatus}" (onShow)="dropdownStates.subStatus = true"
                        (onHide)="dropdownStates.subStatus = false"></p-dropdown>
                    <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySubStatus.errors && (resolveInquiryForm.controls.inquirySubStatus.dirty || resolveInquiryForm.controls.inquirySubStatus.touched)">
                        <img src="assets/newMessage/error.svg" class="error"> Inquiry Sub-Status is Required
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center resolveDir" style="margin-top: 10px;" #checkBoxForceResolveDiv>
                <div class="label-text resolveLabel"></div>
                <div class="dd-comp ddMob">
                    <div class="custom-control custom-checkbox" >
                        <input type="checkbox" class="custom-control-input" id="forceResolve" formControlName="forceResolve" (change)="forceResolve($event)" >
                        <label class="custom-control-label" for="forceResolve">Force Resolve</label>
                    </div>
                </div>
            </div>

            <!-- panel to show non mandatory fields -->
            <div [hidden] = "!showMoreFields">
                <div *ngIf="mandatoryForResolveFlags[0] && (mandatoryForResolveFlags[0] && !mandatoryForResolveFlags[0].isGfidMandatory)" class="input-group mb-2 " style="margin-left: 0px; padding-left:22px;">
                <div class="lookup-container">
                    <button class="btn btn-default lookup-button">
                        <img src="assets/qwyn/icons/search-blue.svg" alt="Search" class="lookup-icon" />
                    </button>
                    <a href="#" class="TextGFP lookup-link" (click)="callGFIDWindow()">External Client ID / Name Look up</a>
                </div>
                </div>

                <div class="input-group mb-2 " [ngClass]="{'hidden-content': hideQueries}" >
                    <label class="form-label">Queries:</label>
                    <div class="input-container">
                        <input class="resolve-form-control" type="text" formControlName="queryCount">
                        <div *ngIf="resolveInquiryForm.controls.queryCount.errors?.max && (resolveInquiryForm.controls.queryCount.dirty || resolveInquiryForm.controls.queryCount.touched)" class="">
                            <img src="assets/newMessage/error.svg" class="error" alt="Error"><span class="errorMsg"> Please enter a query count from 1-9999 inclusive</span>
                        </div>
                        <div *ngIf="resolveInquiryForm.controls.queryCount.errors?.min && (resolveInquiryForm.controls.queryCount.dirty || resolveInquiryForm.controls.queryCount.touched)" class="">
                            <img src="assets/newMessage/error.svg" class="error" alt="Error"><span class="errorMsg"> Please enter valid query count!</span>
                        </div>
                    </div>
                </div>

                <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (!mandatoryForResolveFlags[0].isTagMandatory)">
                    <label class="form-label">Tag:</label>
                    <div class="input-container">
                        <p-dropdown [options]="tags" formControlName="tags"
                            [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                            [ngClass]="{'signatureDropdown-open': dropdownStates.tags}" (onShow)="dropdownStates.tags = true"
                            (onHide)="dropdownStates.tags = false" placeholder="Select Tag"></p-dropdown>
                        <div *ngIf="resolveInquiryForm.controls.tags.errors && (resolveInquiryForm.controls.tags.dirty || resolveInquiryForm.controls.tags.touched)"
                             class="">
                            <img src="assets/newMessage/error.svg" class="error"> Tags is Required
                        </div>
                    </div>
                </div>

                <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (!mandatoryForResolveFlags[0]?.isRootCauseMandatory)">
                    <label class="form-label">Cause:</label>
                    <div class="input-container">
                        <p-dropdown [options]="rootCauses" formControlName="rootCause"
                            [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" placeholder="Select Cause"
                            [ngClass]="{'signatureDropdown-open': dropdownStates.cause}" (onShow)="dropdownStates.cause = true"
                            (onHide)="dropdownStates.cause = false"></p-dropdown>
                        <div *ngIf="isSubmitClicked && resolveInquiryForm.controls.rootCause.errors && (resolveInquiryForm.controls.rootCause.dirty || resolveInquiryForm.controls.rootCause.touched)"
                             class="">
                            <img src="assets/newMessage/error.svg" class="error"> Root Cause is Required
                        </div>
                    </div>
                </div>

                <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (!mandatoryForResolveFlags[0].isProcessingRegionMandatory)">
                    <label class="form-label">Region:</label>
                    <div class="input-container">
                        <p-dropdown [options]="processingRegions" formControlName="processingRegion"
                            [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                            [ngClass]="{'signatureDropdown-open': dropdownStates.region}" (onShow)="dropdownStates.region = true"
                            (onHide)="dropdownStates.region = false" placeholder="Select Region"></p-dropdown>
                        <div *ngIf="resolveInquiryForm.controls.processingRegion.errors && (resolveInquiryForm.controls.processingRegion.dirty || resolveInquiryForm.controls.processingRegion.touched)"
                             class="">
                            <img src="assets/newMessage/error.svg" class="error" alt="Processing Region is Required"><span class="errorMsg"> Processing Region is Required</span>
                        </div>
                    </div>
                </div>

                <div class="input-group mb-2 " *ngIf="mandatoryForResolveFlags[0] && (!mandatoryForResolveFlags[0].isInqSourceMandatory)">
                    <label class="form-label">Source:</label>
                    <div class="input-container">
                        <p-dropdown [options]="inquirySourceList" formControlName="inquirySource"
                            [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" placeholder="Select Source"
                            [ngClass]="{'signatureDropdown-open': dropdownStates.source}" (onShow)="dropdownStates.source = true"
                            (onHide)="dropdownStates.source = false"></p-dropdown>
                        <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySource.errors && (resolveInquiryForm.controls.inquirySource.dirty || resolveInquiryForm.controls.inquirySource.touched)">
                            <img src="assets/newMessage/error.svg" class="error" alt="Inquiry Source is Required"><span class="errorMsg"> Inquiry Source is Required</span>
                        </div>
                    </div>
                </div>

                <div class="input-group mb-2 " *ngIf="enableInquirySubStatusFlag && mandatoryForResolveFlags[0] && (!mandatoryForResolveFlags[0]?.enableInquirySubStatus)">
                    <label class="form-label">Sub-Status:</label>
                    <div class="input-container">
                        <p-dropdown [options]="inquirySubStatusList" formControlName="inquirySubStatus"
                            [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                            [ngClass]="{'signatureDropdown-open': dropdownStates.subStatus}" (onShow)="dropdownStates.subStatus = true"
                            (onHide)="dropdownStates.subStatus = false" placeholder="Select Sub-Status"></p-dropdown>
                        <div class="invalid-feedback" *ngIf="resolveInquiryForm.controls.inquirySubStatus.errors && (resolveInquiryForm.controls.inquirySubStatus.dirty || resolveInquiryForm.controls.inquirySubStatus.touched)">
                            <img src="assets/newMessage/error.svg" class="error"> Inquiry Sub-Status is Required
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-group mb-2 " style="margin-top:8px; height:28px;">
                <label class="form-label"></label>
                <div class="input-container checkbox-wrapper" [class.hide]="hide">
                    <input type="checkbox" class="custom-checkbox" id="resolveAll" formControlName="resolveAll" (change)="resolveForAllChecked($event)">
                    <label class="checkbox-label" for="resolveAll">Resolve for all my groups</label>
                </div>
            </div>
            <div class="input-group mb-2 " style="margin-top:8px; margin-bottom:20px; height:28px;">
                <label class="form-label"></label>
                <div class="input-container checkbox-wrapper" [class.hide]="hide">
                    <input type="checkbox" class="custom-checkbox" id="resolveAllocation" formControlName="resolveAllocation" (change)="resolveAllocationChecked($event)">
                    <label class="checkbox-label" for="resolveAllocation">Action – No Reply</label>
                </div>
            </div>

            <div class="input-group mb-2 ">
                <label class="form-label">Comment:</label>
                <div class="input-comments-container">
                    <!--<input type="text" formControlName="comments" class="resolve-form-control" placeholder="Type here" />-->
                    <textarea type="text" class="resolve-form-control" placeholder="Type here" formControlName="comments" rows="5"></textarea>
                </div>
            </div>

            <div class="d-flex flex-row align-items-center resolveDir" style="margin-bottom: 5px">
                <div class="errorMsg">{{lockErrorMsg}}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center" style="margin-top: 20px; margin-left: 20px; margin-right: 40px;margin-bottom: 8px;">
                <div *ngIf="!toggleMoreFields">
                    <label for="from" class="form-more-label" (click)="showHideMoreFields()">
                        <img [src]="'assets/Inbox/less-fields-icon-resolve.svg'" alt="Resolve" class="resolve-img">
                        More Fields
                    </label>
                </div>
                <div *ngIf="toggleMoreFields">
                    <label for="from" class="form-more-label" (click)="showHideMoreFields()">
                        <img [src]="'assets/Inbox/more-fields-icon-resolve.svg'" alt="Resolve">
                        Less Fields
                    </label>
                </div>
                <div class="buttons-container">
                    <p-button label="Cancel" (onClick)="cancelResolveInquiry(resolveInquiryForm)" styleClass="p-button-danger me-2"></p-button>
                    <p-button label="Resolve" type="submit" styleClass="custom-submit-button"></p-button>
                </div>
            </div>
        </form>
<!--
        <div class="input-group mb-2 ">
            <div *ngIf="!toggleMoreFields">
                <label for="from" class="form-more-label" (click)="showHideMoreFields()">
                    <img [src]="'assets/Inbox/less-fields-icon.svg'" alt="Resolve">
                    More Fields
                </label>
            </div>
            <div *ngIf="toggleMoreFields">
                <label for="from" class="form-more-label" (click)="showHideMoreFields()">
                    <img [src]="'assets/Inbox/less-fields-icon.svg'" alt="Resolve">
                    Less Fields
                </label>
            </div>
            <div class="buttons-container">
                <p-button label="Cancel" (onClick)="resetResolveInquiry(resolveInquiryForm)" styleClass="p-button-danger me-2"></p-button>
                <p-button label="Resolve" type="submit" styleClass="custom-submit-button"></p-button>
            </div>
        </div>
-->
    </div>
</p-dialog>
<!-- redesigned resolved form -->

<p-dialog [(visible)]="displayError" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'blacklistModel'"
          [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Information</h6>
            <button type="button" (click)="closeModal('error')" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
            </button>
        </div>
    </p-header>
    <div class="success-msg" [innerHTML]="errMsg"></div>
</p-dialog>
<!--changes regarding C170665-365If GFPID is mandatory,provide an option to assign gfcid click on resolve option -->
<app-gfid-search [isNewMessage]="true" (addClicked)="getGFID($event)"></app-gfid-search>
